(ns web3.components.html
  (:require [web3.view :as v]
            [web3.utils :as utils]
            [reagent.core :as r]))

(defn fetch-html [{:keys [state props] :as this}]
  (when-let [url (:url props)]
    (swap! state assoc
           :fetched-url url
           :loading? true)
    (utils/fetch url
                 {:format :text
                  :on-complete (fn [text]
                                 (when (= url (:fetched-url @state))
                                   (swap! state assoc
                                          :fetched-text text
                                          :loading? false)))})))

(v/defview static-html
  {:component-will-mount
   fetch-html
   :component-will-receive-props
   (fn [{:keys [state] :as this} [_ {:keys [url]}]]
     (when (and (not (:loading? @state))
                (not= url (:url @state)))
       (fetch-html this)))}
  []
  (let [{:keys [state]} (r/current-component)]
    [:div.static-markdown
     [:section
      [:div.container
       [:article
        [:div {:dangerouslySetInnerHTML {:__html (:fetched-text @state)}}]]]]]))